<div class="workflow-wrapper">

  <!-- Step Number Circle -->
  <!-- <div class="step-indicator mat-elevation-z3">
    {{ activeIndex + 1 }}
  </div> -->

  <!-- Steps -->
  <div class="steps-container">
    <div
      class="step"
      *ngFor="let step of steps; let i = index"
      (click)="onStepClick(i)"
      [ngClass]="{
        'active': isActive(i),
        'completed': isCompleted(i),
        'disabled': step.disabled
      }"
    >
     <span class="step-content">
  {{ step.label }}
  <span *ngIf="step.hasError" class="error-dot">!</span>
</span>

    </div>
  </div>

</div>